exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.contacts-tray[data-v-94418d12] {\n\tmax-height: 150px;\n\toverflow-y: scroll;\n\toverflow-x: hidden;\n\tpadding: 10px;\n}\n.phone-button-bar[data-v-94418d12] {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-ms-flex-wrap: wrap;\n\t    flex-wrap: wrap;\n\t-webkit-box-align: center;\n\t    -ms-flex-align: center;\n\t        align-items: center;\n\tgap: 4px;\n\tmargin-bottom: 10px;\n}\n.queue-position[data-v-94418d12] {\n\tfont-size: 12px;\n\tcolor: #909399;\n\twhite-space: nowrap;\n\tmargin-left: 4px;\n}\n", ""]);

// exports
